// extracted by mini-css-extract-plugin
export default {"root":"classes_root__bI7jX","small":"classes_small__QP2L3","medium":"classes_medium__s9GYO","large":"classes_large__Wt0wD"};